import { GraphQLClient } from 'graphql-request';
var host = 'https://graphql.contentful.com';
export var client = new GraphQLClient("".concat(host, "/content/v1/spaces/").concat(process.env.REACT_APP_CONTENTFUL_SPACE), {
  headers: {
    authorization: "Bearer ".concat(process.env.REACT_APP_CONTENTFUL_TOKEN)
  }
});
export var previewClient = new GraphQLClient("".concat(host, "/content/v1/spaces/").concat(process.env.REACT_APP_CONTENTFUL_SPACE), {
  headers: {
    authorization: "Bearer ".concat(process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN)
  }
});